<template>
  <div class="select-store-component">
    <el-dialog
      :title="$t('lcd.Devices.Display Info')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="dialog-screen-display"
      width="700px"
      append-to-body
    >
      <div
        style="
          width: 656px;
          height: 656px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- {{ currentDisplayData.bindTemplate }} -->

        <div class="currentPreview">
          <div
            class="preview800"
            v-if="
              currentDisplayData.installType == 5002 ||
              currentDisplayData.installType == 5004
            "
          >
            <div
              v-for="(item, index) in JSON.parse(
                currentDisplayData.bindTemplate
              )"
              :key="index"
            >
              <video
                class="previewVideo"
                v-if="item.type == 'video'"
                :src="item.files[0].name"
                :style="{
                  width: item.area.width / 2 + 'px',
                  height: item.area.height / 2 + 'px',
                  top: item.area.top / 2 + 'px',
                  left: item.area.left / 2 + 'px',
                  'z-index': item.area.height == 1280 ? 0 : 1,
                }"
                autoplay
                loop
              ></video>
              <el-image
                class="previewImg"
                :style="{
                  width: item.area.width / 2 + 'px',
                  height: item.area.height / 2 + 'px',
                  top: item.area.top / 2 + 'px',
                  left: item.area.left / 2 + 'px',
                }"
                v-if="item.type == 'img'"
                :src="item.files[0].name"
                fit="contain"
              ></el-image>
            </div>
          </div>
          <div
            class="preview1280"
            v-if="
              currentDisplayData.installType == 5001 ||
              currentDisplayData.installType == 5003
            "
          >
            <div
              v-for="(item, index) in JSON.parse(
                currentDisplayData.bindTemplate
              )"
              :key="index"
            >
              <video
                class="previewVideo"
                v-if="item.type == 'video'"
                :src="item.files[0].name"
                :style="{
                  width: item.area.width / 2 + 'px',
                  height: item.area.height / 2 + 'px',
                  top: item.area.top / 2 + 'px',
                  left: item.area.left / 2 + 'px',
                  'z-index': item.area.height == 1280 ? 0 : 1,
                }"
                autoplay
                loop
              ></video>
              <el-image
                class="previewImg"
                :style="{
                  width: item.area.width / 2 + 'px',
                  height: item.area.height / 2 + 'px',
                  top: item.area.top / 2 + 'px',
                  left: item.area.left / 2 + 'px',
                }"
                v-if="item.type == 'img'"
                :src="item.files[0].name"
                fit="contain"
              ></el-image>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: "selectStore",
  components: {},
  props: {
    currentDisplayData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
    };
  },
  created() {},
  watch: {
    dialogVisible(val) {
      if (val) {
        console.log("打开了", typeof this.currentDisplayData);
        console.log("打开了", this.currentDisplayData);
      }
    },
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },

    // 取消选择
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-screen-display {
  margin-top: 0 !important;
  margin-bottom: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .el-dialog__body {
    height: 400px;
    padding: 20px;
    box-sizing: border-box;
  }
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px !important;
    background-color: pink;
  }
  .select-store-bd {
    margin: 0 auto;
    width: 80%;
    ::v-deep .el-radio {
      margin-top: 5px;
      padding: 10px 0;
      width: 100%;
    }
  }
  .box {
    height: 330px;
    margin-top: 20px;
  }
  .el-table thead {
    display: none;
  }
  .el-button {
    width: 110px;
  }
  .el-tree-node__content {
    height: 45px;
  }
  .el-table td.el-table__cell {
    border: none;
    width: 100%;
  }
  .el-table td.el-table__cell > .cell {
    justify-content: flex-start;
  }
  .el-table__row {
    display: flex;
  }
  // ::v-deep .el-radio{
  //   margin-top: 5px;
  //   padding: 20px 0;
  //   width: 100%;
  // }
  ::v-deep .el-table {
    .el-table__header {
      width: 100% !important;
    }
    th.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
    td.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .is-group tr:nth-child(2) .el-checkbox {
      display: none;
    }
  }

  // 重置样式
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-dialog__footer {
    padding: 20px 0;
  }
  .el-radio {
    padding: 14px 0;
    margin-bottom: 0;
  }

  .itemBtn {
    cursor: pointer;
    color: red;
  }
}
.preview800,
.preview1280 {
  width: 416px;
  height: 656px;
  border: 8px solid #333;
  border-radius: 10px;
  background-color: #333;
  position: relative;
  overflow: hidden;
}
.preview1280 {
  width: 656px;
  height: 416px;
}
.previewVideo,
.previewImg {
  position: absolute;
}
</style>